import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Container,
	Row,
	Col,
	FormGroup,
	Label,
	Card,
	CardBody,
	Input,
	Table,
	Collapse,
} from 'reactstrap';
import {
	KeyboardArrowDownOutlined,
	KeyboardArrowUpOutlined,
	LinkOutlined,
} from '@mui/icons-material';
import CurrencyInput from 'react-currency-input';
import { Box } from '@mui/material';
import { symbolPriceFormatter, convertPriceToInt } from '~/helpers/price';
import { LoaderLista } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { SubHeader } from '~/components/SubHeader';
import { color } from '~/assets/styles/colors';
import { ModalGerarLink } from '~/views/Client/Simulador/Modal/GerarLink';
import * as ActionsSimulador from '~/store/modules/client/simulador/actions';

import ReactGA from 'react-ga4';
import { TextError, TrStyled, ButtonStyled, ButtonStyledSimular, ButtonStyledGerarLink } from './styles';



export default function Simulador() {

	const { user } = useSelector((state) => state.auth);
	const simulacao = useSelector((state) => state.clientSimulador);
	const [abreTabela, setAbreTabela] = useState(true);
	const dispatch = useDispatch();
	const [collapseTabelaLojista, setCollapseTabelaLojista] = useState(false);
	const [collapseValorLiquido, setCollapseValorLiquido] = useState(false);

	const [list, setList] = useState([]);
	const [modal, setModal] = useState(false);
	const [link, setLink] = useState({});

	// Constante para travar geração de link
	const [simulou, setSimulou] = useState(false);

	const parcelasSemLink = [ '22x', '23x', '24x'];

	const [button, setButton] = useState({
		maquinaVirtual: !user.dados.maquina_fisica,
		maquinaFisica: user.dados.maquina_fisica,
		parcelaLojista: true,
		parcelaCliente: false,
		pagamentoCredito: true,
		pagamentoDebito: false,
		pagamentoLojista: true,
		pagamentoCliente: false,
	});

	const [body, setBody] = useState({
		lojista_id: `${user.dados.user_id}`,
		tabela: '0',
		tipo: user.dados.maquina_fisica ? 'FISICA' : 'VIRTUAL',
		valor: 0,
	});

	const [valueError, setValueError] = useState(false);

	const [params, setParams] = useState('lojista');

	const [r2Selected, setR2Selected] = useState(false);
	const [r1Selected, setR1Selected] = useState(false);
	const [r0Selected, setR0Selected] = useState(false);
	const [parviSelected, setParviSelected] = useState(false);

	const r2List = [
		'70203799000956',
		'70203799000107',
		'70203799001170',
		'70203799001090',
		'70203799000522',
	]


	const r0List = [
		'10064798000199',
	]


	function handlerTabelaLojista(value) {
		if (value !== '') {
			setBody({ ...body, tabela: value });
		} else {
			setBody({ ...body, tabela: '' });
		}
	}

	function handlerFiltrarMaquinaVirtual() {
		setSimulou(true);

		setButton({
			...button,
			maquinaVirtual: true,
			maquinaFisica: false,
		});
		setBody({ ...body, tipo: 'VIRTUAL' });
	}

	// useEffect(() => {
	// 	if (abreTabela) {
	// 		handlerSimular();
	// 	}
	// }, [button.maquinaVirtual, button.pagamentoCliente, body.tabela]);

	function handlerFiltrarMaquinaFisica() {
		setSimulou(true);
		setButton({
			...button,
			maquinaVirtual: false,
			maquinaFisica: true,
		});

		setBody({ ...body, tipo: 'FISICA' });
	}

	function handlerFiltrarParcelaLojista() {
		setSimulou(true);
		setButton({
			...button,
			parcelaLojista: true,
			parcelaCliente: false,
		});
	}
	function handlerFiltrarParcelaCliente() {
		setSimulou(true);
		setButton({
			...button,
			parcelaLojista: false,
			parcelaCliente: true,
		});
	}

	function handlerFiltrarPagamentoLojista() {
		setSimulou(true);
		setButton({
			...button,
			pagamentoLojista: true,
			pagamentoCliente: false,
		});
		setBody({ ...body, tabela: '0' });
		setParams('lojista');
	}

	function handlerFiltrarPagamentoCliente() {
		setSimulou(true);
		setButton({
			...button,
			pagamentoLojista: false,
			pagamentoCliente: true,
		});
		setParams('cliente');
	}

	// function handlerFiltrarPagamentoCredito() {
	// 	setSimulou(true);
	// 	setButton({
	// 		...button,
	// 		pagamentoCredito: true,
	// 		pagamentoDebito: false,
	// 	});
	// }
	// function handlerFiltrarPagamentoDebito() {
	// 	setSimulou(true);
	// 	setButton({
	// 		...button,
	// 		pagamentoCredito: false,
	// 		pagamentoDebito: true,
	// 	});
	// }

	function handlerSimular() {
		setSimulou(false);
		if (body.valor === 0 || body.valor === '0,00') {
			setValueError(true);
		} else {
			const novoValor = convertPriceToInt(body.valor);
			dispatch(
				ActionsSimulador.requestSimulador(params, {
					...body,
					valor: novoValor * 100,
				})
			);
			setAbreTabela(true);
		}
		handleClickMeioCobrancaGA4(button.maquinaFisica)
		handleClickTaxaGA4(button.pagamentoCliente)
		button.maquinaFisica && handleClickModoPagamentoGA4(button.pagamentoCredito)
		button.maquinaVirtual && handleClickParcelasGA4(button.parcelaCliente)
		handleClickSimularGA4();
	}

	const toggleModal = useCallback(() => {
		setModal((oldState) => !oldState);
	}, []);

	function handlerGerarLink(item) {
		setLink(item);
		handleClickGerarLinkTravadoGA4();
		toggleModal();
	}

	function gerarLinkCliente() {
		setLink({
			opcao: "",
			tipo_operacao: 2,
			tipo_operacao_str: "Credito Parcelado",
			valor_digitado: convertPriceToInt(body.valor),
			valor_liquido: 0,
			valor_parcela: 0,
			escolha_cliente: button.parcelaCliente,
		});
		handleClickLinkFlexGA4();
		toggleModal();
	}

	function handleClickGerarLinkTravadoGA4() {
		ReactGA.event({
			category: "gerar_link_travado_click",
			action: `Gerar Link Pagamento Travado`,
			label: `Gerando Link Pagamento Travado`,
		});
	}

	function handleClickLinkFlexGA4() {
		ReactGA.event({
			category: "link_flex_click",
			action: `Seleciona Link Flex`,
			label: `Selecionando Link Flex`,
		});
	}

	function handleClickMeioCobrancaGA4(tipo) {
		ReactGA.event({
			category: "seleciona_meio_cobranca_click",
			action: `Seleciona Meio de Cobrança ${tipo ? 'Máquina' : 'Link'}`,
			label: `Selecionando Meio de Cobrança ${tipo ? 'Máquina' : 'Link'}`,
		});
	}

	function handleClickTaxaGA4(tipo) {
		ReactGA.event({
			category: "seleciona_paga_taxa_click",
			action: `Seleciona ${tipo ? 'Cliente' : 'Lojista'} Paga Taxa`,
			label: `Selecionando ${tipo ? 'Cliente' : 'Lojista'} Paga Taxa`,
		});
	}

	function handleClickModoPagamentoGA4(tipo) {
		ReactGA.event({
			category: "seleciona_modo_pagamento_click",
			action: `Seleciona Modo Pagamento ${tipo ? 'Crédito' : 'Débito'}`,
			label: `Selecionando Modo Pagamento ${tipo ? 'Crédito' : 'Débito'}`,
		});
	}

	function handleClickParcelasGA4(tipo) {
		ReactGA.event({
			category: "seleciona_parcelas_click",
			action: `${tipo ? 'Cliente' : 'Lojista'} Seleciona Parcela`,
			label: `${tipo ? 'Cliente' : 'Lojista'} Selecionando Parcela`,
		});
	}

	function handleClickSimuladorGA4() {
		ReactGA.event({
			category: "simulador_click",
			action: "Simulador",
			label: "Simulando pagamento",
		});
	}

	function handleClickSimularGA4() {
		ReactGA.event({
			category: "simulador_click",
			action: "Simulou",
			label: "Clicando em simular pagamento",
		});
	}

	useEffect(() => {
		if(simulacao.lista.length > 0){
			setList([])
		}

		if(r2List.filter(item => item === user.dados.documento).length > 0){
			setBody({ ...body, tabela: '2' });
			setR2Selected(true)
		}else if(
			user.dados.documento.startsWith('16835903') ||
			user.dados.documento.startsWith('24355547') ||
			user.dados.documento.startsWith('35715234') ||
			user.dados.documento.startsWith('63411623003') ||
			user.dados.documento.startsWith('07784006') ||
			user.dados.documento.startsWith('07234453') ||
			user.dados.documento.startsWith('16355380')){
			setParviSelected(true)
			handlerFiltrarPagamentoCliente()
			setBody({ ...body, tabela: '1' });
			setR1Selected(true)
		} else if(r0List.filter(item => item === user.dados.documento).length > 0){
			setBody({ ...body, tabela: '0' });
			setR0Selected(true)
		}else{
			setR2Selected(false)
			setR0Selected(false)
			setParviSelected(false)
		}

		handleClickSimuladorGA4();
	}, []);

	useEffect(() => {
		handlerSimular()
	}, [button]);

	const isFirstRender = useRef(true);
	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
		}else{
			setList(simulacao.lista || []);
		}
	}, [simulacao]);

	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Simulador',
						link: '/client/simulador',
					},
				]}
			/>
			<Row className="mt-5 mb-5 border-bottom pb-2">
				<Col className="d-flex aling-items-center">
					<Text size="large">Simulador</Text>
				</Col>
			</Row>
			<Row>
				<Col lg={abreTabela ? '4' : '12'}>
					<Card style={{ boxShadow: 'unset' }}>
						<CardBody>
							<Row>
								<Col lg={abreTabela ? '12' : '4'}>
									<FormGroup>
										<Label className="d-block">
											MEIO DE COBRANÇA
										</Label>
										<Row>
											{user.dados.simulador_fisico && (
												<Col>
													<ButtonStyled
														className="w-100 my-0 notranslate"
														disabled={
															button.maquinaFisica
														}
														onClick={() =>
															handlerFiltrarMaquinaFisica()
														}>
														Máquina
													</ButtonStyled>
												</Col>
											)}
											{user.dados.simulador_virtual && (
												<Col>
													<ButtonStyled
														className="w-100 my-0"
														disabled={
															!button.maquinaFisica
														}
														onClick={() =>
															handlerFiltrarMaquinaVirtual()
														}>
														Link
													</ButtonStyled>
												</Col>
											)}
										</Row>
									</FormGroup>
								</Col>

								<Col lg={abreTabela ? '12' : '4'}>
									<FormGroup>
										<Label className="d-block">
											QUEM PAGARÁ AS
											{' '}
											<b>TAXAS?</b>
										</Label>
										<Row>
											{!parviSelected &&
												<Col>
													<ButtonStyled
														className="w-100 my-0"
														disabled={
															button.pagamentoLojista
														}
														onClick={() =>
															handlerFiltrarPagamentoLojista()
														}>
														Lojista
													</ButtonStyled>
												</Col>
											}
											<Col>
												<ButtonStyled
													className="w-100 my-0"
													disabled={
														button.pagamentoCliente
													}
													onClick={() =>
														handlerFiltrarPagamentoCliente()
													}>
													Cliente
												</ButtonStyled>
											</Col>
										</Row>
									</FormGroup>
								</Col>

								{button.maquinaVirtual ?
									<Col lg={abreTabela ? '12' : '4'}>
										<FormGroup>
											<Label className="d-block">
												QUEM ESCOLHERÁ AS
												{' '}
												<b>PARCELAS?</b>
											</Label>
											<Row>
												<Col>
													<ButtonStyled
														className="w-100 my-0"
														disabled={
															button.parcelaLojista
														}
														onClick={() =>
															handlerFiltrarParcelaLojista()
														}>
														Lojista
													</ButtonStyled>
												</Col>
												<Col>
													<ButtonStyled
														className="w-100 my-0"
														disabled={
															button.parcelaCliente
														}
														onClick={() =>
															handlerFiltrarParcelaCliente()
														}>
														Cliente
													</ButtonStyled>
												</Col>
											</Row>
										</FormGroup>
									</Col>
									:
									<>
										{/* <Col lg={abreTabela ? '12' : '4'}>
											<FormGroup>
												<Label className="d-block">
													COMO O CLIENTE IRÁ PAGAR?
												</Label>
												<Row>
													<Col>
														<ButtonStyled
															className="w-100 my-0"
															disabled={
																button.pagamentoCredito
															}
															onClick={() =>
																handlerFiltrarPagamentoCredito()
															}>
															Crédito
														</ButtonStyled>
													</Col>
													<Col>
														<ButtonStyled
															className="w-100 my-0"
															disabled={
																button.pagamentoDebito
															}
															onClick={() =>
																handlerFiltrarPagamentoDebito()
															}>
															Débito
														</ButtonStyled>
													</Col>
												</Row>
											</FormGroup>
										</Col> */}
									</>
								}

							</Row>

							<Row className="mt-4">
								{button.pagamentoLojista === false && (
									<Col lg={abreTabela ? '12' : '4'}>
										<FormGroup>
											<Label
												className="d-block"
												style={{ marginBottom: 13 }}>
												QUANTO VOCÊ DESEJA RECEBER?
											</Label>
											<CurrencyInput
												type="text"
												className="form-control"
												placeholder="00,00"
												decimalSeparator=","
												thousandSeparator="."
												value={body.valor.toString()}
												onChangeEvent={(input) => {
													setBody({
														...body,
														valor: input.target
															.value,
													});
													setValueError(false);
												}}
											/>
											{valueError && (
												<TextError>
													Por favor, informe o valor
												</TextError>
											)}
										</FormGroup>
									</Col>
								)}
								{button.pagamentoLojista === false &&
									parseInt(user.dados.lojista_id, 10) !==
									11668 && (
										<Col lg={abreTabela ? '12' : '4'}>
											<FormGroup>
												<Label
													className="d-flex align-items-center"
													onClick={() =>
														setCollapseTabelaLojista(
															!collapseTabelaLojista
														)
													}>
													TABELA DO LOJISTA
													{!collapseTabelaLojista ? (
														<KeyboardArrowDownOutlined />
													) : (
														<KeyboardArrowUpOutlined />
													)}
												</Label>
												<Collapse
													isOpen={
														collapseTabelaLojista
													}>
													<Input
														disabled={r2Selected || r0Selected || r1Selected}
														type="select"
														onChange={(input) =>
															handlerTabelaLojista(
																input.target
																	.value
															)
														}>
														<option value="">
															Selecione
														</option>
														<option value="0" selected={r0Selected}>
															R0
														</option>
														<option value="1" selected={r1Selected}>
															R1
														</option>
														<option value="2" selected={r2Selected}>
															R2
														</option>
														<option value="4">
															R4
														</option>
														<option value="6">
															R6
														</option>
														<option value="8">
															R8
														</option>
														<option value="10">
															R10
														</option>
														<option value="12">
															R12
														</option>
													</Input>
												</Collapse>
											</FormGroup>
										</Col>
									)}
								{button.pagamentoLojista === false &&
									parseInt(user.dados.lojista_id, 10) !==
									11668 && (
										<Col lg={abreTabela ? '12' : '4'}>
											<FormGroup>
												<Label
													className="d-flex align-items-center"
													onClick={() =>
														setCollapseValorLiquido(
															!collapseValorLiquido
														)
													}>
													LÍQUIDO A RECEBER
													{!collapseValorLiquido ? (
														<KeyboardArrowDownOutlined />
													) : (
														<KeyboardArrowUpOutlined />
													)}
												</Label>
												<Collapse
													isOpen={
														collapseValorLiquido
													}>
													<Input
														type="text"
														disabled
														value={symbolPriceFormatter(
															simulacao.valor /
															100,
															'simulador'
														)}
													/>
												</Collapse>
											</FormGroup>
										</Col>
									)}

								{button.pagamentoLojista === true && (
									<Col lg={abreTabela ? '12' : '4'}>
										<FormGroup>
											<Label className="d-block">
												QUANTO O CLIENTE VAI PAGAR?
											</Label>
											<CurrencyInput
												type="text"
												className="form-control"
												placeholder="00,00"
												decimalSeparator=","
												thousandSeparator="."
												value={body.valor.toString()}
												onChangeEvent={(input) => {
													setBody({
														...body,
														valor: input.target
															.value,
													});
													setValueError(false);
												}}
											/>
											{valueError && (
												<TextError>
													Por favor, informe o valor
												</TextError>
											)}
										</FormGroup>
									</Col>
								)}
							</Row>
						</CardBody>
					</Card>
					{button.maquinaVirtual && simulou && <Text style={{ color: color.grayDark, fontSize: 14 }}>Obs.: Clique em simular para liberar a geração de link.</Text>}
					<div className="d-flex justify-content-end mb-4">
						{button.parcelaCliente && button.maquinaVirtual && abreTabela && (
							<ButtonStyledGerarLink
								disabled={simulou}
								color="primary"
								onClick={() => gerarLinkCliente()}>
								<LinkOutlined className="mr-2" />
								GERAR LINK
							</ButtonStyledGerarLink>
						)}
						<ButtonStyledSimular
							className="notranslate"
							onClick={() => handlerSimular()}>
							SIMULAR
						</ButtonStyledSimular>
					</div>
				</Col>
				<Col className={abreTabela ? 'd-block' : 'd-none'}>
					<Box style={{padding: '20px', backgroundColor: 'white'}}>
						<LoaderLista
							lista={list}
							loading={simulacao.loading}
							error={simulacao.error}>
							<Text style={{ marginBottom:'10px' }}><b>SIMULAÇÃO</b></Text>
							<Table responsive>
								<thead>
									<TrStyled>
										<th style={{ textAlign: 'center' }}>Modalidade</th>
										<th style={{ textAlign: 'center' }}>Valor Parcela</th>
										<th style={{ textAlign: 'center' }}>Valor Transação</th>
										{/* <th>Valor a Receber</th>
										<th>Valor a Ceder</th> */}
										{((button.pagamentoLojista) || (simulacao.show_credito && button.pagamentoCliente)) && (
											<th style={{ textAlign: 'center' }}>Valor Líquido</th>
										)}
										{simulacao.show_credito &&  <th style={{ textAlign: 'center' }}>Crédito Gerado</th>}
										{(button.maquinaVirtual && button.parcelaLojista) && <th>#</th>}
									</TrStyled>
								</thead>
								<tbody>
									{
										list.length > 0 && (
										list.map((item, index) => {
											if (item.tipo_operacao === 1 && button.maquinaVirtual) {
												return null;
											}
											return (
												<tr
													key={`${item.valor_parcela}${item.tipo_operacao_str}${index}`}>
													<td style={{ backgroundColor: index % 2 === 0 ? '#fff' : color.modalGreen, textAlign: 'center' }}><b>{item.tipo_operacao  === 1 ? 'Débito' : item.opcao}</b></td>
													<td style={{ backgroundColor: index % 2 === 0 ? '#fff' : color.modalGreen, textAlign: 'center'  }}>
														{symbolPriceFormatter(
															Math.trunc(item.valor_parcela) /
															100,
															'simulador'
														)}
													</td>
													<td style={{ backgroundColor: index % 2 === 0 ? '#fff' : color.modalGreen, textAlign: 'center'  }}>
														{symbolPriceFormatter(
															Math.trunc(item.valor_digitado) /
															100,
															'simulador'
														)}
													</td>
													{/* <td>
														{symbolPriceFormatterSplit((70 / 100), item.valor_digitado, 'participante')}
													</td>
													<td>
														{symbolPriceFormatterSplit((30 / 100), item.valor_digitado, 'ambos')}
													</td> */}
													{((button.pagamentoLojista) || (simulacao.show_credito && button.pagamentoCliente))  && (
														<td style={{ backgroundColor: index % 2 === 0 ? '#fff' : color.modalGreen, textAlign: 'center'  }}>
															{symbolPriceFormatter(
																item.valor_liquido /
																100
															)}
														</td>
													)}
													{simulacao.show_credito &&
														<td style={{ backgroundColor: index % 2 === 0 ? '#fff' : color.modalGreen, textAlign: 'center'  }}>
															{item.credito_gerado ? symbolPriceFormatter(
																Math.trunc(item.credito_gerado) /
																100
															) : ''}
														</td>
													}
													{button.maquinaVirtual && button.parcelaLojista && (
														<td style={{ backgroundColor: index % 2 === 0 ? '#fff' : color.modalGreen, textAlign: 'center'  }}>
															{parcelasSemLink.includes(
																item.opcao
															) ? (
																<div>-</div>
															) : (
																<div
																	role="none"
																	onClick={() =>
																		!simulou ? handlerGerarLink(
																			item
																		) :
																			console.log('')
																	}
																	className="d-flex justify-content-center align-items-center"
																	style={{
																		width: 40,
																		backgroundColor:
																			!simulou ? color.yellow : color.grayMedium,
																		borderRadius:
																			'20px',
																		cursor: 'pointer',
																	}}>
																	<LinkOutlined />
																</div>
															)}
														</td>
													)}
												</tr>
											);
										})
									)}
								</tbody>
							</Table>
						</LoaderLista>
					</Box>

				</Col>
			</Row>
			<ModalGerarLink button={button} toggle={toggleModal} setModal={setModal} isOpen={modal} link={link} setLink={setLink} simulacao={simulacao} />
		</Container>
	);
}
